import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from "@angular/core";
import localeKo from "@angular/common/locales/ko";
import { provideRouter, TitleStrategy } from "@angular/router";
import { appRoutes } from "./app.routes";
import { provideClientHydration } from "@angular/platform-browser";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideToastr } from "ngx-toastr";
import { provideMarkdown } from "ngx-markdown";
import { environment } from "../environments/environment";
import { ApiModule } from "@xxlist/api-client";
import { httpInterceptor } from "./libs/http.interceptor";
import { registerLocaleData } from "@angular/common";

registerLocaleData(localeKo, "ko");

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([httpInterceptor]), withFetch()),
    provideToastr(),
    { provide: LOCALE_ID, useValue: "ko" },
    provideAnimations(),
    provideMarkdown(),
    provideRouter(appRoutes),
    importProvidersFrom(
      ApiModule.forRoot({
        rootUrl: environment.baseUrl,
      })
    ),
  ],
};
